

export class StockSKUSearchRequest{

  sku: string | null;
  hubPlantId: string | null;
  facility: string | null;
  storer: string | null;

  constructor(){
    this.sku = null;
    this.hubPlantId = null;
    this.facility = null;
    this.storer = null;
  }
}
